(function() {
    'use strict';
    angular
        .module('portalApp')
        .factory('ResultSeries', ResultSeries);

    ResultSeries.$inject = ['$resource'];

    function ResultSeries ($resource) {
        var resourceUrl =  'api/result-series/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
